export default "__VITE_ASSET__OvBUmr9U__"